import { useEffect, useState } from "react";
import { Input } from "../ui/input";
import { SearchIcon } from "lucide-react";

const DebouncedInput = ({
  value: initValue,
  onChange,
  debounce = 500,
  ...props
}) => {
  const [value, setValue] = useState(initValue);
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    setValue(initValue);
  }, [initValue]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);
    return () => clearTimeout(timeout);
  }, [debounce, onChange, value]);

  return (
    <div className="relative w-full">
      {isFocused && (
        <div className="absolute left-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
          <SearchIcon />
        </div>
      )}

      <Input
        {...props}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className={`w-full py-2 bg-transparent border-zinc-200 border-b-2 duration-300 ${
          isFocused ? "w-auto focus-visible:ring-indigo-500 pl-10" : "w-1/4"
        }`}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      />
    </div>
  );
};

export default DebouncedInput;
